module.exports = __webpack_public_path__ + "customer.3b60d6b40b87fcfe971545178a1d0a25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/customer.svg
// module id = 333
// module chunks = 0